import React from 'react';
const TrainingCenters = () => <div className="service-page"><h1>Training Centers</h1><p>Professional training centers for skill development.</p></div>;
export default TrainingCenters;
